import { ManagementInsight, ManagementQuote } from '@toggle/toggle';
import React from 'react';

import { config } from '~/config';

import { ManagementQuotes } from './management-quotes/ManagementQuotes';
import * as S from './ManagementCommentarySection.styles';
import { StrategicInsights } from './strategic-insights/StrategicInsights';

interface ManagementCommentarySectionProps {
  managementInsights: ManagementInsight[];
  quotes: ManagementQuote[];
}

export const ManagementCommentarySection = ({
  managementInsights,
  quotes,
}: ManagementCommentarySectionProps) => {
  const isLocal = config.app.isLocalEnvironment;
  const isProd = config.app.environment === 'prod' && !isLocal;

  return (
    <S.Root>
      <StrategicInsights managementInsights={managementInsights} />
      {!isProd && <ManagementQuotes quotes={quotes} />}
    </S.Root>
  );
};
